import { render, staticRenderFns } from "./com-partner.vue?vue&type=template&id=25db9c4e&scoped=true&"
import script from "./com-partner.vue?vue&type=script&lang=js&"
export * from "./com-partner.vue?vue&type=script&lang=js&"
import style0 from "./com-partner.vue?vue&type=style&index=0&id=25db9c4e&scoped=true&lang=sass&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25db9c4e",
  null
  
)

export default component.exports